export default {"src":"/_next/static/media/comissions-calendar-icon.57793b80.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};